import React from 'react';
import { Link } from 'react-router-dom';
import { useWebLocale } from '../../../contexts/WebLocaleContext';
import baseline, { appCopy, appTextStyle } from '../../../app-ui/baseline';
import { resultCategories, displayResultCount } from '../../../features/search/resultPresentation';

export default function SearchResultHeader({ query, results = {} }) {
  const { locale } = useWebLocale();
  const total = resultCategories.reduce(
    (sum, { bucket }) => sum + (results[bucket]?.total || 0),
    0,
  );
  if (!query?.trim() || !total) return null;
  return (
    <>
      <div className="pp-search-result-heading" style={{ gap: baseline.tokens.spacing.md }}>
        <h1 style={appTextStyle(baseline.tokens.typography.sectionTitle)}>
          {appCopy(locale, 'search.resultsFor', { query })}
        </h1>
        <span style={appTextStyle(baseline.contentText.metadata)}>
          {appCopy(locale, 'common.itemCount', { count: total })}
        </span>
      </div>
      <nav
        className="pp-search-counts"
        aria-label={locale === 'en' ? 'Search categories' : '검색 결과 카테고리'}
        style={{ paddingBottom: baseline.tokens.spacing.md }}
      >
        {resultCategories.map(({ route, bucket, label }) => {
          const count = results[bucket]?.total || 0;
          const name = appCopy(locale, label);
          const content = (
            <>
              <span style={appTextStyle(baseline.tokens.typography.bodyMedium)}>{name}</span>
              <span style={appTextStyle(baseline.contentText.metadata)}>
                {displayResultCount(count)}
              </span>
            </>
          );
          return count ? (
            <Link
              key={route}
              to={`/search/${route}?q=${encodeURIComponent(query)}`}
              aria-label={appCopy(locale, 'search.openAllResults', { count, label: name })}
            >
              {content}
            </Link>
          ) : (
            <span key={route} aria-disabled="true">
              {content}
            </span>
          );
        })}
      </nav>
    </>
  );
}
